
import sortBy from 'lodash-es/sortBy'
import moment from 'moment'
import { seasonalPalette } from './constants/colors'


function getChartColors(seasonal, movingAvg) {
  if(movingAvg) {
    return seasonal ? seasonalPalette : ['#2E93fA', '#2E93fA'];
  } else {
    return seasonal ? seasonalPalette : ['#2E93fA', '#2E93fA'];
  }
}

function createApexTimeseries(dates, values, name) {
  let series = dates.map(function(item, i) {
    return [moment.utc(item, 'YYYY-MM-DD').valueOf(), values[i]];
  });
  series = sortBy(series, item => item[0]);

  return [{name: name, data: series}];
}

function createStackedApexTimeseries(dates, values, groups) {
  let series = {};
  groups.forEach((groupName, index) => {
    if(!series[groupName]) {
      series[groupName] = [];
    }

    series[groupName].push([
      moment.utc(dates[index], 'YYYY-MM-DD').valueOf(),
      values[index]
    ]);
  });


  let data = Object.keys(series).map(groupName => ({
    name: groupName,
    data: series[groupName].sort(function(a,b){return a[0] >= b[1];}),
  }))

  return data.sort(function(a,b){return a.name.localeCompare(b.name);});
}

function createSeasonalApexTimeseries(dates, values, name, suffix) {
  let currentYear = null;
  let currentSeries = null;
  let series = [];
  let suffixToAdd = suffix ? suffix : '';

  const timeseriesYear = moment(dates[dates.length - 1]).toDate().getFullYear();

  dates.forEach((date, i) => {
    let momentDate = moment.utc(date, 'YYYY-MM-DD');
    if(currentYear !== momentDate.year()) {
      currentYear = momentDate.year();
      currentSeries = {
        name: `${name} ${currentYear} ${suffixToAdd}`,
        data: []
      };
      series.push(currentSeries);
    }

    momentDate.set('year', timeseriesYear);  // fake year
    currentSeries.data.push([momentDate.valueOf(), values[i]]);
  });
  return series;
}

function getMovingAverage(values, window) {
  const windowSize = window ? window : 20;

  return values.map((record, index) => {
    if(index >= windowSize-1) {
      let windowValues = values.slice(index-(windowSize-1), index+1);
      return windowValues.reduce((x, y) => x + y, 0) / windowSize;
    }
  });
}

function datesValuesToMovingAvg(dates, values, window) {
  const windowSize = window ? window : 20;
  let avgDates = dates.slice(windowSize-1);
  let avgValues = getMovingAverage(values, windowSize);
  avgValues = avgValues.slice(windowSize-1);
  return [avgDates, avgValues];
}

function timeseriesToMovingAvg(series, window) {
  const windowSize = window ? window : 20;

  return series.map(item => {
    let dates = item.data.map(x => x[0]).slice(windowSize-1);
    let values = item.data.map(x => x[1]);
    values = getMovingAverage(values, windowSize).slice(windowSize-1);

    return {
      name: item.name + ' (moving avg)',
      data: values.map((value, index) => [dates[index], value]),
    };
  });
}

function seasonalDateFormatter(val) {
  return moment.utc(val).format('D MMM');
}


export {
  getChartColors,
  createApexTimeseries,
  createStackedApexTimeseries,
  createSeasonalApexTimeseries,
  datesValuesToMovingAvg,
  timeseriesToMovingAvg,
  seasonalDateFormatter,
}
